import { axiosInstance } from "./AxiosConfig";

export const getMicrosoftAuthUrl = async () => {
  const userData = localStorage.getItem("user_data");
  const token = userData ? JSON.parse(userData)?.token : null;
  const locale = localStorage.getItem("locale") || "en";

  const response = await axiosInstance.get("/mentor/v1/microsoft/auth-url", {
    headers: {
      Authorization: token ? `Bearer ${token}` : null,
      "Accept-Language": locale,
    },
  });
  return response.data.data;
};

export const getMicrosoftStatus = async () => {
  const userData = localStorage.getItem("user_data");
  const token = userData ? JSON.parse(userData)?.token : null;
  const locale = localStorage.getItem("locale") || "en";

  const response = await axiosInstance.get("/mentor/v1/microsoft/status", {
    headers: {
      Authorization: token ? `Bearer ${token}` : null,
      "Accept-Language": locale,
    },
  });
  return response.data.data;
};

export const disconnectMicrosoft = async () => {
  const userData = localStorage.getItem("user_data");
  const token = userData ? JSON.parse(userData)?.token : null;
  const locale = localStorage.getItem("locale") || "en";

  const response = await axiosInstance.delete(
    "/mentor/v1/microsoft/disconnect",
    {
      headers: {
        Authorization: token ? `Bearer ${token}` : null,
        "Accept-Language": locale,
      },
    },
  );
  return response;
};
